import fetch from '../utils/fetch'

export function getPcreditEmergencySwitch () {
  return fetch({
    url: '/pcredit/emergency-switch',
    method: 'get'
  })
}

export function savePcreditEmergencySwitch (data) {
  return fetch({
    url: '/pcredit/emergency-switch',
    method: 'put',
    data
  })
}
